module.exports = __webpack_public_path__ + "static/arthur-ashe-798f156028a50162f7566a4413b3586e.jpg";